<template>
  <div
    class="sub-categories"
    v-bind="{
      ...(mounted && {
        class: {
          'l2-flyout': stack[0]?.id === props.data.id,
          'l3-flyout': stack[1]?.id === props.data.id,
          'l4-flyout': stack[2]?.id === props.data.id,
        },
        'data-flyout': data.id,
        'aria-label': data.text,
      }),
    }"
    :data-id="data.id"
    :data-url="data.url"
    :data-tracking="trackingObjToString(data.tracking)"
    :data-text="data.text"
    :data-parent="data.parentId"
    :data-cat-splash="data.isCatSplash || undefined"
  >
    <CategoriesList
      :data="data.children"
      :category-id="data.id"
      :title="data.text"
      :level="getLevel(props.data.id)"
      class="padding-top-xs"
      @on-select="showSubCategories"
    />
  </div>
</template>

<script setup>
import { onUpdated } from 'vue';
import { useMounted } from '@vueuse/core';

import { useMobileNav } from '~/composables/useMobileNav';
import CategoriesList from './CategoriesList.common';
import { trackingObjToString } from '~/utils/restoreStateFromDom';
import scrollToTop from '~/utils/scrollToTop';

const props = defineProps({
  data: {
    /** @type import('vue').PropType<MobileFlyoutElement> */
    type: Object,
    required: true,
  },
});

const emits = defineEmits(['onSelect']);
const mounted = useMounted();
const { stack } = useMobileNav();

function getLevel(dataId) {
  if (stack.value[0]?.id === dataId) return 'l2';
  if (stack.value[1]?.id === dataId) return 'l3';
  if (stack.value[2]?.id === dataId) return 'l4';
  return 'l1';
}

function showSubCategories(params) {
  emits('onSelect', {
    categoryId: params.categoryId.toString(),
    pos: params.pos,
    title: params.title,
    url: params.url,
  });
}

onUpdated(() => {
  scrollToTop('.mobile-nav-wrap');
});
</script>

<style lang="scss">
.sub-categories {
  ul {
    gap: 16px;
  }

  .categories-list--account li:last-child {
    border-top: $hr-gray-divider;
    padding-top: rem-calc(26);
    margin-top: rem-calc(10);
  }
}
</style>
